import React, { useContext, useEffect, useState, useCallback } from "react";
import { AuthContext } from "../../comum/Context/auth.jsx";
import { api } from "../../services/api.js";
import Menu from "../../comum/Menu/menu.jsx";
import Footer from "../../comum/Footer/index.jsx";
import BirthdayCarousel from "../Components/CardAniversario/cardaniversario.jsx";
import Foto from "../Components/Foto";
import Cropper from 'react-easy-crop';
import getCroppedImg from '../Utils/cropImage.js';

import { Modal, Button, Form, Row, Col, Badge, Spinner, InputGroup, Collapse } from "react-bootstrap";
import { format, addDays, differenceInYears, differenceInMonths, differenceInDays, addYears, addMonths } from "date-fns";
import { ptBR } from "date-fns/locale";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

import conviteAeflorImg from './../../../public/Images/aeflor_fantasia_2026.jpg';

import img1 from './../../../public/Images/1.png';
import img2 from './../../../public/Images/2.png';
import img3 from './../../../public/Images/3.png';
import img4 from './../../../public/Images/4.png';
import img5 from './../../../public/Images/5.png';
import "./index.css";

const sentimentos = [
    { id: 1, label: "", png: img1 },
    { id: 2, label: "", png: img2 },
    { id: 3, label: "", png: img3 },
    { id: 4, label: "", png: img4 },
    { id: 5, label: "", png: img5 },
];

const DEFAULT_USER = "https://upload.wikimedia.org/wikipedia/commons/0/03/Sem_imagem.jpg";
const cacheKey = (chapa) => `foto_${String(chapa)}`;
const getCachedPhoto = (chapa) => localStorage.getItem(cacheKey(chapa));
const setCachedPhoto = (chapa, dataUrl) => { try { localStorage.setItem(cacheKey(chapa), dataUrl); } catch { } };

const getFavoritosKey = (chapaUser) => {
    if (!chapaUser) return "favoritos_menus";
    return `favoritos_${String(chapaUser).padStart(6, "0")}`;
};

const formatarDataSemFuso = (dataStr) => {
    if (!dataStr) return "--";
    const trechoData = String(dataStr).substring(0, 10);
    const partes = trechoData.split("-");
    if (partes.length !== 3) return dataStr;
    const [ano, mes, dia] = partes;
    return `${dia}/${mes}/${ano}`;
};

function Home() {
    const navigate = useNavigate();
    const { logado } = useContext(AuthContext);
    const [usuarioInfo, setUsuarioInfo] = useState(null);
    const [fotoPerfilUrl, setFotoPerfilUrl] = useState(null);
    const [sentimentoImg, setSentimentoImg] = useState(null);
    const [admissaoFormatada, setAdmissaoFormatada] = useState("");
    const [tempoEmpresa, setTempoEmpresa] = useState("");
    const [fotoAmpliada, setFotoAmpliada] = useState(null);
    const [showModalFotoPerfil, setShowModalFotoPerfil] = useState(false);
    const [qtdemsg, setQtdemsg] = useState(0);

    const [exibirAniversariantes, setExibirAniversariantes] = useState(true);

    // Inicialização do estado já lendo do localStorage para exibir 'Recentes' imediatamente
    const [favoritos, setFavoritos] = useState(() => {
        const chapaUser = localStorage.getItem("chapa");
        if (!chapaUser) return [];
        const keyFav = getFavoritosKey(chapaUser);
        const cacheLocal = localStorage.getItem(keyFav);
        if (cacheLocal) {
            try {
                return JSON.parse(cacheLocal);
            } catch (e) {
                return [];
            }
        }
        return [];
    });

    // Permissões
    const chapa = localStorage.getItem("chapa");
    const codLojaUser = Number(usuarioInfo?.loja || usuarioInfo?.LOJA || usuarioInfo?.filial ||
        usuarioInfo?.FILIAL || 0);
    const exibeFilaAtendimento = codLojaUser > 50;

    const isRestrito = chapa?.startsWith("90");
    const AcessoSap = localStorage.getItem("SAPADM") === "S";
    const permiteVendas = localStorage.getItem("permiteVendas") === "S";
    const permitePonto = localStorage.getItem("permitePonto") === "S";
    const permiteCheckList = localStorage.getItem("CHECKLIST") === "S";
    const permiteCadastroCheckTI = localStorage.getItem("TICADCHECKLIST") === "S";
    const permiteVistoria = localStorage.getItem("vistoriaLoja") === "S";
    const eDiretor = localStorage.getItem("diretor") === "S";
    const permiteInventario = localStorage.getItem("INVENTARIO") === "S";
    const permiteRegional = localStorage.getItem("permiteRegional") === "S" || eDiretor;
    const permiteFerias = localStorage.getItem("FERIAS") === "S";
    const permiteDashBoardRH = localStorage.getItem("RHDASHBOARD") === "S";
    const permiteConciliacao = localStorage.getItem("CONCILIACARTAO") === "S";
    const permiteFichaFinanceira = localStorage.getItem("FICHAFINANCEIRA") === "S";
    const permiteFichaFinanceiraAP = localStorage.getItem("FICHAFINANCEIRAAPROV") === "S";
    const permiteControleEpi = localStorage.getItem("CONTROLEEPI") === "S";
    const itsAcessoRegional = chapa === '900010' || chapa === '900001';
    const isVistoria = permiteVistoria || permiteRegional || eDiretor;

    const permissoesChamado = JSON.parse(localStorage.getItem("setorchamado") || "[]");
    const permiteAtendimento = permissoesChamado.length > 0;

    // Crop / Edição da foto de perfil
    const [imagemCrop, setImagemCrop] = useState(null);
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
    const [croppedPreview, setCroppedPreview] = useState(null);

    const [pendenciaAtual, setPendenciaAtual] = useState(null);
    const [showModalPendencia, setShowModalPendencia] = useState(false);
    const [motivoAssinatura, setMotivoAssinatura] = useState("");
    const [processandoAcao, setProcessandoAcao] = useState(false);
    const [showModalAeflor, setShowModalAeflor] = useState(false);

    const [pastaAberta, setPastaAberta] = useState(null);
    const [termoBusca, setTermoBusca] = useState("");

    const hojeStr = format(new Date(), "dd/MM");
    const amanhaStr = format(addDays(new Date(), 1), "dd/MM");
    const depoisStr = format(addDays(new Date(), 2), "dd/MM");

    const hasPhoto = (url) => !!url && url !== DEFAULT_USER;

    // Sincronizar favoritos do backend ao carregar a página
    useEffect(() => {
        const chapaUser = localStorage.getItem("chapa");
        if (!chapaUser) return;

        const keyFav = getFavoritosKey(chapaUser);

        api.get(`/usuario/favoritos/${chapaUser}`)
            .then((res) => {
                if (res.data && Array.isArray(res.data) && res.data.length > 0) {
                    setFavoritos(res.data);
                    localStorage.setItem(keyFav, JSON.stringify(res.data));
                }
            })
            .catch(() => { });
    }, [chapa]);

    useEffect(() => {
        const info = localStorage.getItem("usuarioInfo");
        const chapaUser = localStorage.getItem("chapa");
        const storedQtdemsg = localStorage.getItem("msg");

        const carregarSentimentoLocal = () => {
            const sentimento = localStorage.getItem("sentido");
            if (sentimento) {
                const s = sentimentos.find((x) => x.id.toString() === sentimento.toString());
                if (s) setSentimentoImg(s.png);
            }
        };

        const msgCount = storedQtdemsg ? parseInt(storedQtdemsg, 10) : 0;
        setQtdemsg(msgCount);

        const fetchUnreadMessages = async (uChapa) => {
            if (!uChapa) return;
            try {
                const res = await api.get(`/usuario/notificacoes?usuario=${uChapa}&status=E`);
                const newMsgCount = res.data.total;
                localStorage.setItem("msg", String(newMsgCount));
                setQtdemsg(newMsgCount);
            } catch (error) {
                console.error("Erro ao buscar notificações não lidas:", error);
            }
        };

        if (info) {
            const parsed = JSON.parse(info);
            setUsuarioInfo(parsed);

            fetchUnreadMessages(chapaUser);
            carregarSentimentoLocal();

            window.addEventListener("sentimentoAtualizado", carregarSentimentoLocal);

            const cachedPerfil = getCachedPhoto(chapaUser) || DEFAULT_USER;
            setFotoPerfilUrl(cachedPerfil);

            (async () => {
                const res = await api.get(`/usuario/foto/${chapaUser}`).catch(() => null);
                const admissaoIso = res?.data?.dataadmissao || null;
                if (res?.data?.foto) {
                    const freshUrl = `data:image/jpeg;base64,${res.data.foto}`;
                    if (freshUrl !== cachedPerfil) {
                        setCachedPhoto(chapaUser, freshUrl);
                        setFotoPerfilUrl(freshUrl);
                    }
                }
                if (admissaoIso) {
                    const adm = new Date(admissaoIso.split('T')[0] + 'T00:00:00');
                    setAdmissaoFormatada(format(adm, "dd/MM/yyyy", { locale: ptBR }));
                    const hoje = new Date();
                    const anos = differenceInYears(hoje, adm);
                    const meses = differenceInMonths(hoje, addYears(adm, anos)) % 12;
                    const base = addMonths(addYears(adm, anos), meses);
                    const dias = differenceInDays(hoje, base);
                    setTempoEmpresa(`${anos}a ${meses}m ${dias}d`);
                }
            })();

            verificarPendenciasComunicados(chapaUser, eDiretor, permiteRegional);
        }

        return () => {
            window.removeEventListener("sentimentoAtualizado", carregarSentimentoLocal);
        };
    }, []);

    const registrarAcessoMenu = (item) => {
        setPastaAberta(null);
        const chapaUser = localStorage.getItem("chapa") || usuarioInfo?.chapa;
        const keyFav = getFavoritosKey(chapaUser);

        let listaAtual = [...favoritos];
        listaAtual = listaAtual.filter(f => f.to !== item.to);
        listaAtual.unshift({ to: item.to, text: item.text, icon: item.icon });
        if (listaAtual.length > 6) {
            listaAtual = listaAtual.slice(0, 6);
        }

        setFavoritos(listaAtual);
        localStorage.setItem(keyFav, JSON.stringify(listaAtual));

        api.post("/usuario/favoritos", {
            chapa: chapaUser,
            to: item.to,
            text: item.text,
            icon: item.icon || "fa-star"
        }).catch((err) => console.error("Erro ao sincronizar favorito com o BD:", err));

        if (item.to.startsWith("http://") || item.to.startsWith("https://")) {
            window.open(item.to, "_blank");
        } else {
            navigate(item.to);
        }
    };

    const handleChangeFoto = (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = () => {
            setImagemCrop(reader.result);
            setCroppedPreview(null);
        };
        reader.readAsDataURL(file);
    };

    const onCropComplete = useCallback(async (_, croppedPixels) => {
        setCroppedAreaPixels(croppedPixels);

        if (imagemCrop) {
            try {
                const croppedUrl = await getCroppedImg(imagemCrop, croppedPixels);
                setCroppedPreview(croppedUrl);
            } catch (err) {
                console.error("Erro ao gerar preview:", err);
            }
        }
    }, [imagemCrop]);

    async function gravarFotoHome() {
        try {
            if (!imagemCrop || !croppedAreaPixels) return;

            const croppedUrl = await getCroppedImg(imagemCrop, croppedAreaPixels);
            const response = await fetch(croppedUrl);
            const blob = await response.blob();

            const reader = new FileReader();
            reader.readAsDataURL(blob);

            reader.onloadend = async () => {
                const base64Image = reader.result;
                const chapaUser = localStorage.getItem("chapa");

                const data = {
                    tipo: "",
                    imagem: base64Image,
                    loja: usuarioInfo?.loja || 0,
                };

                await api.post("/usuario/foto/" + chapaUser, data);

                setCachedPhoto(chapaUser, base64Image);
                setFotoPerfilUrl(base64Image);

                setImagemCrop(null);
                setCroppedPreview(null);
                setShowModalFotoPerfil(false);
            };
        } catch (err) {
            console.error(err);
            alert("Erro ao salvar foto");
        }
    }

    const verificarPendenciasComunicados = async (chapaUser, isDir, isReg) => {
        let temPendenciaAtiva = false;
        try {
            if (isReg) {
                const res = await api.get(`/usuario/comunicacao/1`);
                const lista = res.data || [];
                if (lista.length > 0) {
                    setPendenciaAtual({ tipoPendencia: "AVISO_REdirecionar", mensagem: "Existem comunicados pendentes para avaliação da Regional." });
                    setShowModalPendencia(true);
                    temPendenciaAtiva = true;
                    return;
                }
            }

            if (!temPendenciaAtiva && isDir) {
                const resDiretor = await api.get(`/usuario/comunicacao/4?chapa=${chapaUser}`);
                const listaDiretor = resDiretor.data || [];
                if (listaDiretor.length > 0) {
                    setPendenciaAtual({ tipoPendencia: "AVISO_REdirecionar", mensagem: "Existem comunicados pendentes para aprovação da Diretoria." });
                    setShowModalPendencia(true);
                    temPendenciaAtiva = true;
                    return;
                }
            }

            if (!temPendenciaAtiva) {
                const resDep = await api.get(`/usuario/comunicacao/3?chapa=${chapaUser}`);
                const listaDep = resDep.data || [];
                if (listaDep.length > 0) {
                    setPendenciaAtual({ tipoPendencia: "AVISO_REdirecionar", mensagem: "Existem comunicados pendentes de dependentes para avaliação." });
                    setShowModalPendencia(true);
                    temPendenciaAtiva = true;
                    return;
                }
            }

            if (!temPendenciaAtiva) {
                const resCiencia = await api.get(`/usuario/comunicacao/6`);
                const listaCiencia = resCiencia.data || [];
                const meuComunicadoCiencia = listaCiencia.find(
                    (c) => String(c.chapa) === String(chapaUser)
                );

                if (meuComunicadoCiencia) {
                    setPendenciaAtual({ ...meuComunicadoCiencia, tipoPendencia: "CIENCIA" });
                    setShowModalPendencia(true);
                    temPendenciaAtiva = true;
                }
            }
        } catch (err) {
            console.error("Erro ao verificar pendências de comunicados:", err);
        }

        const hoje = new Date();
        const dataLimite = new Date(2026, 9, 31, 23, 59, 59);

        if (!temPendenciaAtiva && hoje <= dataLimite) {
            const hojeStr = format(hoje, "yyyy-MM-dd");
            const keyPopupLocal = `popupAeflorVisto_${chapaUser}_${hojeStr}`;

            if (localStorage.getItem(keyPopupLocal) === "S") return;

            try {
                const resPop = await api.get(`/usuario/popup-aeflor/${chapaUser}`);
                const ultimaDataVisualizada = resPop.data?.ultima_data;

                if (ultimaDataVisualizada !== hojeStr) {
                    setTimeout(() => {
                        setShowModalAeflor(true);
                    }, 800);
                } else {
                    localStorage.setItem(keyPopupLocal, "S");
                }
            } catch (e) {
                console.error("Erro ao consultar visto do Pop-up via BD:", e);
            }
        }
    };

    const registrarVistoPopupBD = (chapaUser) => {
        const hojeStr = format(new Date(), "yyyy-MM-dd");
        const keyPopupLocal = `popupAeflorVisto_${chapaUser}_${hojeStr}`;

        localStorage.setItem(keyPopupLocal, "S");

        api.post("/usuario/popup-aeflor", {
            chapa: chapaUser,
            data: hojeStr
        }).catch((e) => console.error("Erro ao registrar visto do pop-up no BD:", e));
    };

    const handleConfirmarCiencia = async () => {
        if (!pendenciaAtual) return;
        setProcessandoAcao(true);

        const chapaUser = localStorage.getItem("chapa");

        try {
            await api.post("/usuario/comunicacao", {
                codigo: pendenciaAtual.cod_operacao,
                status: 10,
                usuario: chapaUser,
                operacao: String(pendenciaAtual.tipooperacao),
                observacao: motivoAssinatura || "Ciência registrada pelo colaborador.",
                autorizado: "1",
            });

            Swal.fire({
                icon: "success",
                title: "Sucesso",
                text: "Ciência registrada com sucesso!",
            });

            setShowModalPendencia(false);
            setMotivoAssinatura("");
            setPendenciaAtual(null);

            const hojeStr = format(new Date(), "yyyy-MM-dd");
            const resPop = await api.get(`/usuario/popup-aeflor/${chapaUser}`);
            if (resPop.data?.ultima_data !== hojeStr) {
                setShowModalAeflor(true);
            }
        } catch (err) {
            Swal.fire({
                icon: "error",
                title: "Erro",
                text: err.response?.data?.erro || err.message,
            });
        } finally {
            setProcessandoAcao(false);
        }
    };

    useEffect(() => { if (!logado) window.location.href = "/"; }, [logado]);

    const handleIrParaInscricaoAeflor = () => {
        const chapaUser = localStorage.getItem("chapa");
        registrarVistoPopupBD(chapaUser);
        setShowModalAeflor(false);
        window.location.href = "/arbor/aeflor#ultimo-evento";
    };

    const handleFecharModalAeflor = () => {
        const chapaUser = localStorage.getItem("chapa");
        registrarVistoPopupBD(chapaUser);
        setShowModalAeflor(false);
    };

    const abrirAmpliacaoFoto = (fotoUrl, nome, lojaOuChapa) => {
        if (!hasPhoto(fotoUrl)) return;
        setFotoAmpliada({ foto: fotoUrl, nome, info: lojaOuChapa });
    };

    const goToNotificacoes = () => {
        window.location.href = "/arbor/notificacoes/";
    };

    if (!usuarioInfo) return (
        <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
            <Spinner animation="border" style={{ color: '#8b0000' }} />
        </div>
    );

    const nomeFilialExibicao =
        usuarioInfo?.nomefilial ||
        usuarioInfo?.NOMEFILIAL ||
        (usuarioInfo?.loja ? `Loja ${usuarioInfo.loja}` : "") ||
        (usuarioInfo?.LOJA ? `Loja ${usuarioInfo.LOJA}` : "") ||
        usuarioInfo?.filial ||
        usuarioInfo?.FILIAL ||
        "";

    const gruposMenu = [
        {
            id: "aeflor",
            titulo: "AEFLOR",
            icone: "fa-user-plus",
            visivel: (!isRestrito || itsAcessoRegional),
            links: [
                { to: "/arbor/aeflor/assistencia", text: "Assistência Financeira", icon: "fa-hand-holding-usd" },
                { to: "/arbor/aeflor/convenio", text: "Convênio", icon: "fa-credit-card" },
                { to: "/arbor/aeflor", text: "Eventos", icon: "fa-calendar" }
            ].sort((a, b) => a.text.localeCompare(b.text, 'pt-BR'))
        },
        {
            id: "rh",
            titulo: "Recursos Humanos",
            icone: "fa-users",
            visivel: (!isRestrito || itsAcessoRegional),
            links: [
                { to: "/arbor/rh/chamado", text: "Atendimento RH", icon: "fa-question-circle" },
                { to: "/arbor/atestado", text: "Atestados", icon: "fa-user-md" },
                { to: "/arbor/escala/", text: "Escala Trabalho", icon: "fa-calendar" },
                { to: "/arbor/holerite/", text: "Holerites", icon: "fa-file-text-o" },
                { to: "/arbor/dadosfunc/", text: "Meus Dados", icon: "fa-address-card" },
                { to: "/arbor/notificacoes/", text: "Notificações", icon: "fa-bell" },
                { to: "/arbor/ponto/", text: "Ponto", icon: "fa-clock-o" },
                { to: "/arbor/restaurante", text: "Refeição", icon: "fa-cutlery" }
            ].sort((a, b) => a.text.localeCompare(b.text, 'pt-BR'))
        },
        {
            id: "operacoes",
            titulo: "Operações Loja",
            icone: "fa-building",
            visivel: true,
            links: [
                permiteAtendimento && { to: "/arbor/chamado/atendimento", text: "Atendimento Chamados", icon: "fa-wrench" },
                permiteVendas && { to: "/arbor/produto/auditoria/", text: "Auditoria Produto", icon: "fa-cubes" },
                permiteCadastroCheckTI && { to: "/arbor/checklist/cadastro/", text: "Cadastro CheckList", icon: "fa-list" },
                permiteCheckList && { to: "/arbor/checklist/checklist/", text: "CheckList TI", icon: "fa-check-square-o" },
                permiteVendas && { to: "/arbor/equipamentos/", text: "Equipamentos", icon: "fa-shopping-cart" },
                permiteRegional && { to: "/arbor/equipamentos/admin", text: "Equipamentos ADMIN", icon: "fa-cart-plus" },
                permiteCheckList && { to: "/arbor/equipamentosti/", text: "Equipamentos TI", icon: "fa-desktop" },
                { to: "/arbor/produto/", text: "Etiqueta", icon: "fa-barcode" },
                permiteInventario && { to: "/arbor/Loja/inventario", text: "Inventários", icon: "fa-cubes" },
                { to: "/arbor/chamado", text: "Meus Chamados", icon: "fa-user" },
                AcessoSap && { to: "/arbor/sap/", text: "SAP Preços", icon: "fa-money" },
                { to: "/arbor/validade/", text: "Validade", icon: "fa-calendar" },
                isVistoria && { to: "/arbor/loja/vistoria", text: "Vistoria Checklist", icon: "fa-pencil-square-o" }
            ].filter(Boolean).sort((a, b) => a.text.localeCompare(b.text, 'pt-BR'))
        },
        {
            id: "pessoas_gestao",
            titulo: "Pessoas & Gestão",
            icone: "fa-address-book",
            visivel: true,
            links: [
                permitePonto && { to: "/arbor/escala/cadastro", text: "Cadastro de Escala", icon: "fa-calendar-plus-o" },
                permitePonto && { to: "/arbor/rh/clima/", text: "Clima e Humor", icon: "fa-smile-o" },
                (permiteRegional || permiteDashBoardRH || eDiretor) && { to: "/arbor/comunicado/", text: "Comunicação RH", icon: "fa-address-book" },
                (permiteRegional || permiteDashBoardRH || eDiretor || permiteControleEpi) && { to: "/arbor/rh/controleepi", text: "Controle de EPI", icon: "fa-shield" }, // <-- ADICIONADOpermiteDashBoardRH && { to: "/arbor/rh/dashboard", text: "DashBoard RH", icon: "fa-bar-chart" },
                (permiteRegional || permiteFerias) && { to: "/arbor/rh/ferias/", text: "Férias", icon: "fa-calendar" },
                permiteVendas && { to: "/arbor/rh/acidente/", text: "Ocorrências", icon: "fa-user-md" },
                permitePonto && { to: "/arbor/ponto/ocorrencias/", text: "Ocorrências Ponto", icon: "fa-clock-o" },
                permiteVendas && { to: "/arbor/usuario/consinco/", text: "Operador PDV", icon: "fa-users" }
            ].filter(Boolean).sort((a, b) => a.text.localeCompare(b.text, 'pt-BR'))
        },
        {
            id: "vendas",
            titulo: "Vendas",
            icone: "fa-line-chart",
            visivel: permiteVendas,
            links: [
                { to: "/arbor/vendas/comparativo/", text: "Vendas Comparativo Geral", icon: "fa-line-chart" },
                { to: "/arbor/vendas/secao/", text: "Vendas Depto/Seção", icon: "fa-line-chart" },
                { to: "/arbor/vendas/secao/compara", text: "Vendas Depto/Seção Comparativo", icon: "fa-line-chart" },
                { to: "/arbor/vendas/flash/", text: "Vendas Flash", icon: "fa-bolt" },
                { to: "/arbor/vendas/mes/", text: "Vendas Período", icon: "fa-line-chart" },
                { to: "/arbor/vendas/loja/", text: "Vendas Período Loja", icon: "fa-line-chart" }
            ].filter(Boolean).sort((a, b) => a.text.localeCompare(b.text, 'pt-BR'))
        },
        {
            id: "financeiro",
            titulo: "Financeiro",
            icone: "fa-calculator",
            visivel: (permiteFichaFinanceira || permiteConciliacao || permiteFichaFinanceiraAP),
            links: [
                permiteFichaFinanceiraAP && { to: "/arbor/fin/fichafinanceira/aprovacao", text: "Aprovação Ficha", icon: "fa-line-chart" },
                permiteConciliacao && { to: "/arbor/fin/conciliacao", text: "Conciliação Cartões", icon: "fa-credit-card" },
                permiteFichaFinanceira && { to: "/arbor/fin/fichafinanceira", text: "Ficha Financeira", icon: "fa-university" }
            ].filter(Boolean).sort((a, b) => a.text.localeCompare(b.text, 'pt-BR'))
        },
        {
            id: "ouvidoria",
            titulo: "Ouvidoria e outros",
            icone: "fa-comments",
            visivel: (!isRestrito || chapa === '900010'),
            links: [
                { to: "/arbor/ouvidoria/", text: "Abrir Protocolo", icon: "fa-comments" },
                exibeFilaAtendimento && { to: "/arbor/atendimento/fila", text: "Fila de Atendimento", icon: "fa-users" }
            ].filter(Boolean).sort((a, b) => a.text.localeCompare(b.text, 'pt-BR'))
        }
    ].filter(g => g.visivel && g.links.length > 0);

    return (
        <div className="home-layout-wrapper">
            <Menu modulo="ARBOR" />

            <div className="container-fluid px-3 px-md-4 home-content-container">
                {/* NOTIFICAÇÃO FLUTUANTE */}
                {qtdemsg > 0 && (
                    <div
                        onClick={goToNotificacoes}
                        className="notificacao-badge-float"
                        title={`${qtdemsg} Mensagem(ns) não lida(s)`}
                    >
                        <i className="fa fa-bell" />
                        <span className="badge-count">{qtdemsg}</span>
                    </div>
                )}

                {/* CARD COMPACTO DE PERFIL DO USUÁRIO */}
                <div className="user-profile-compact shadow-sm my-3 border-0">
                    <div className="user-profile-header-bg" />
                    <div className="user-profile-body text-center px-3 pb-3">
                        <div className="foto-container-compact">
                            <img
                                src={fotoPerfilUrl || DEFAULT_USER}
                                alt="Foto do Usuário"
                                className="user-photo-compact shadow-sm"
                                onClick={() => setShowModalFotoPerfil(true)}
                                style={{ cursor: "pointer" }}
                                title="Clique para gerenciar a foto de perfil"
                            />

                            {sentimentoImg && (
                                <img
                                    src={sentimentoImg}
                                    alt="Sentimento"
                                    className="sentimento-flutuante-compact"
                                />
                            )}
                        </div>

                        <h5 className="user-name mt-2 mb-1 text-dark fw-bold">
                            {usuarioInfo.NOME}
                        </h5>

                        {nomeFilialExibicao && (
                            <p className="user-filial text-muted small mb-2 fw-semibold">
                                <i className="fa fa-building-o me-1 text-danger"></i>
                                {nomeFilialExibicao}
                            </p>
                        )}

                        <div className="d-flex flex-wrap justify-content-center gap-1.5 my-2">
                            <Badge bg="danger" className="px-2.5 py-1.5 font-weight-bold">
                                Matrícula: {chapa}
                            </Badge>
                            <Badge bg="secondary" className="px-2.5 py-1.5 text-uppercase">
                                {usuarioInfo.FUNCAO || "Colaborador"}
                            </Badge>
                        </div>

                        {(admissaoFormatada || tempoEmpresa) && (
                            <div className="user-tempo-empresa bg-light rounded-pill py-1 px-3 d-inline-block border mt-1">
                                <small className="text-secondary fw-semibold">
                                    <i className="fa fa-calendar me-1 text-danger"></i>
                                    Admissão: {admissaoFormatada} ({tempoEmpresa})
                                </small>
                            </div>
                        )}
                    </div>
                </div>

                {/* BARRA DE PESQUISA RÁPIDA DE MENUS */}
                <div className="mb-3">
                    <InputGroup size="sm" className="shadow-sm rounded-3 overflow-hidden">
                        <InputGroup.Text className="bg-white border-end-0">
                            <i className="fa fa-search text-muted"></i>
                        </InputGroup.Text>
                        <Form.Control
                            type="text"
                            placeholder="Buscar aplicativo ou funcionalidade..."
                            value={termoBusca}
                            onChange={(e) => setTermoBusca(e.target.value)}
                            className="border-start-0 py-2"
                        />
                        {termoBusca && (
                            <Button variant="outline-secondary" onClick={() => setTermoBusca("")}>
                                <i className="fa fa-times"></i>
                            </Button>
                        )}
                    </InputGroup>
                </div>

                {/* MENU ITINERANTE DOS MAIS ACESSADOS / FAVORITOS */}
                {favoritos.length > 0 && (
                    <div className="favoritos-container mb-4 p-3 bg-white rounded-3 shadow-sm border">
                        <div className="d-flex align-items-center gap-2 mb-2">
                            <i className="fa fa-star text-warning fs-6"></i>
                            <h6 className="m-0 fw-bold text-dark small text-camelcase">Recentes</h6>
                        </div>

                        <div className="favoritos-grid">
                            {favoritos.map((fav, idx) => (
                                <div
                                    key={idx}
                                    className="favorito-item-card"
                                    onClick={() => registrarAcessoMenu(fav)}
                                >
                                    <div className="favorito-icon-box shadow-sm">
                                        <i className={`fa ${fav.icon || 'fa-star'}`}></i>
                                    </div>
                                    <span className="favorito-label">{fav.text}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {/* GRID DE CAIXINHAS / PASTAS ESTILO iOS */}
                <div className="ios-folders-grid mb-4">
                    {gruposMenu.map((grupo) => {
                        const linksFiltrados = termoBusca.trim() === ""
                            ? grupo.links
                            : grupo.links.filter(l => l.text.toLowerCase().includes(termoBusca.toLowerCase()));

                        if (termoBusca.trim() !== "" && linksFiltrados.length === 0) {
                            return null;
                        }

                        const previewLinks = grupo.links.slice(0, 9);

                        return (
                            <div
                                key={grupo.id}
                                className="ios-folder-card"
                                onClick={() => setPastaAberta(grupo)}
                            >
                                <div className="ios-folder-box shadow-sm">
                                    <div className="ios-folder-preview-grid">
                                        {previewLinks.map((link, i) => (
                                            <div key={i} className="ios-mini-icon-box">
                                                <i className={`fa ${link.icon || 'fa-folder-o'}`}></i>
                                            </div>
                                        ))}
                                    </div>
                                    {grupo.links.length > 0 && (
                                        <div className="ios-folder-badge">{grupo.links.length}</div>
                                    )}
                                </div>
                                <span className="ios-folder-title">{grupo.titulo}</span>
                            </div>
                        );
                    })}
                </div>

                {/* CARROSSEL DE ANIVERSARIANTES POSICIONADO ABAIXO DOS MENUS */}
                <div className="aniversariantes-section mb-5 bg-white p-3 rounded-3 shadow-sm border">
                    <div
                        className="d-flex align-items-center justify-content-between cursor-pointer"
                        onClick={() => setExibirAniversariantes(!exibirAniversariantes)}
                        style={{ cursor: "pointer" }}
                    >
                        <div className="d-flex align-items-center gap-2">
                            <i className="fa fa-birthday-cake text-danger fs-5"></i>
                            <h6 className="m-0 fw-bold text-dark">
                                Aniversariantes de Hoje ({hojeStr}), Amanhã ({amanhaStr}) e Depois ({depoisStr})
                            </h6>
                        </div>
                        <Button variant="link" size="sm" className="text-muted p-0 text-decoration-none">
                            <i className={`fa ${exibirAniversariantes ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
                        </Button>
                    </div>

                    <Collapse in={exibirAniversariantes}>
                        <div className="mt-3">
                            <BirthdayCarousel />
                        </div>
                    </Collapse>
                </div>
            </div>

            <Footer />

            {/* MODAL ESTILO iOS FOLDER */}
            <Modal
                show={!!pastaAberta}
                onHide={() => setPastaAberta(null)}
                centered
                className="ios-folder-modal"
                contentClassName="ios-folder-modal-content"
            >
                <Modal.Header closeButton closeVariant="white" className="border-0 pb-0">
                    <Modal.Title className="w-100 text-center text-white fw-bold fs-4">
                        {pastaAberta?.titulo}
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body className="p-4">
                    <div className="ios-app-grid">
                        {pastaAberta?.links.map((link, idx) => (
                            <div
                                key={idx}
                                className="ios-app-item cursor-pointer"
                                onClick={() => registrarAcessoMenu(link)}
                            >
                                <div className="ios-app-icon shadow-sm">
                                    <i className={`fa ${link.icon || 'fa-comments'}`}></i>
                                </div>
                                <span className="ios-app-label">{link.text}</span>
                            </div>
                        ))}
                    </div>
                </Modal.Body>
            </Modal>

            {/* MODAL POP-UP AEFLOR */}
            <Modal show={showModalAeflor} onHide={handleFecharModalAeflor} centered size="lg" className="modal-aeflor-popup">
                <Modal.Header closeButton className="border-0 bg-dark text-white pb-1">
                    <Modal.Title className="fs-5 fw-bold text-center w-100 text-warning">
                        🎉 CONFRATERNIZAÇÃO AEFLOR 2026 🎉
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body className="p-2 bg-dark text-center position-relative modal-aeflor-body">
                    <img
                        src={conviteAeflorImg}
                        alt="Convite AEFLOR Fantasia 2026"
                        className="modal-aeflor-img-full"
                        onClick={() => abrirAmpliacaoFoto(conviteAeflorImg, "Confraternização AEFLOR Fantasia 2026", "AEFLOR")}
                        title="Clique para abrir a foto em tela inteira"
                        style={{ cursor: "zoom-in" }}
                    />
                </Modal.Body>

                <Modal.Footer className="bg-dark border-0 justify-content-center p-2">
                    <Button
                        variant="warning"
                        size="lg"
                        className="fw-bold px-4 py-2 text-dark btn-inscreva-aeflor"
                        onClick={handleIrParaInscricaoAeflor}
                    >
                        🎟️ Me inscrever ➔
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* COMPONENTE NATIVO <Foto /> PARA AMPLIAR IMAGENS EM TELA INTEIRA */}
            <Foto
                show={!!fotoAmpliada}
                onClose={() => setFotoAmpliada(null)}
                foto={fotoAmpliada?.foto}
                nome={fotoAmpliada?.nome}
                info01={fotoAmpliada?.info}
                info02=""
            />

            {/* MODAL COMPLETO DE FOTO DE PERFIL / CROP E BUSCAR FOTO */}
            <Modal
                show={showModalFotoPerfil}
                onHide={() => {
                    setShowModalFotoPerfil(false);
                    setImagemCrop(null);
                    setCroppedPreview(null);
                }}
                centered
                fullscreen="sm-down"
                contentClassName="bg-dark border-0 d-flex flex-column"
            >
                <Modal.Header closeButton closeVariant="white" className="border-0" />

                <Modal.Body className="text-white flex-grow-1 d-flex flex-column align-items-center justify-content-center">
                    {imagemCrop ? (
                        <>
                            <div style={{ position: "relative", width: "100%", maxWidth: 420, height: 320, minHeight: 320, background: "#000" }}>
                                <Cropper
                                    image={imagemCrop}
                                    crop={crop}
                                    zoom={zoom}
                                    aspect={1}
                                    onCropChange={setCrop}
                                    onZoomChange={setZoom}
                                    onCropComplete={onCropComplete}
                                />
                            </div>

                            {croppedPreview && (
                                <div className="text-center mt-3">
                                    <div className="mb-2 small text-muted">Pré-visualização</div>
                                    <img
                                        src={croppedPreview}
                                        alt="preview"
                                        style={{ width: 100, height: 100, borderRadius: "50%", objectFit: "cover", border: "2px solid #fff" }}
                                    />
                                </div>
                            )}
                        </>
                    ) : (
                        <>
                            <img
                                src={fotoPerfilUrl || DEFAULT_USER}
                                alt="Foto de Perfil"
                                style={{ width: "100%", maxWidth: 380, maxHeight: "50vh", objectFit: "contain", borderRadius: "12px" }}
                            />
                            <div className="mt-3 text-center fw-bold">
                                {usuarioInfo?.NOME} ({chapa})
                            </div>
                        </>
                    )}
                </Modal.Body>

                <Modal.Footer className="border-0 justify-content-center gap-2 flex-wrap bg-dark">
                    <input
                        type="file"
                        id="inputFotoHomeModal"
                        hidden
                        accept="image/png,image/jpeg,image/jpg"
                        onChange={handleChangeFoto}
                    />

                    <label htmlFor="inputFotoHomeModal" className="btn btn-outline-light">
                        Buscar foto
                    </label>

                    {imagemCrop && (
                        <Button variant="success" onClick={gravarFotoHome}>
                            Salvar Foto
                        </Button>
                    )}

                    <Button
                        variant="outline-light"
                        onClick={() => {
                            setShowModalFotoPerfil(false);
                            setImagemCrop(null);
                            setCroppedPreview(null);
                        }}
                    >
                        Fechar
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* MODAL AUTOMÁTICO DE AVISO DE PENDÊNCIAS / CIÊNCIA */}
            <Modal
                show={showModalPendencia}
                onHide={() => setShowModalPendencia(false)}
                backdrop="static"
                keyboard={false}
                centered
                size="md"
            >
                <Modal.Header
                    className={
                        pendenciaAtual?.tipoPendencia === "CIENCIA"
                            ? "bg-info text-white"
                            : "bg-warning text-dark"
                    }
                >
                    <Modal.Title className="fs-6 fw-bold">
                        {pendenciaAtual?.tipoPendencia === "CIENCIA"
                            ? "📌 CONFIRMAÇÃO DE CIÊNCIA DE COMUNICADO"
                            : "⚠️ PENDÊNCIAS ENCONTRADAS"}
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body className="text-center py-4">
                    {pendenciaAtual?.tipoPendencia === "AVISO_REdirecionar" ? (
                        <div>
                            <div className="fs-1 mb-2">📋</div>
                            <h5 className="fw-bold text-dark mb-3">{pendenciaAtual.mensagem}</h5>
                            <p className="text-muted small">
                                Acesse a janela de comunicação para visualizar e realizar as devidas aprovações.
                            </p>
                        </div>
                    ) : (
                        pendenciaAtual && (
                            <div className="text-start">
                                <div className="alert alert-light border mb-3">
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <Badge bg="primary">{pendenciaAtual.tipo}</Badge>
                                        <span className="fw-bold text-muted">
                                            Operação #{pendenciaAtual.cod_operacao}
                                        </span>
                                    </div>
                                    <h6 className="fw-bold text-uppercase m-0">{pendenciaAtual.nome}</h6>
                                    <small className="text-muted">
                                        Matrícula: {pendenciaAtual.chapa} | Loja Origem: {pendenciaAtual.filial} ➔ Loja Destino: {pendenciaAtual.lojades}
                                    </small>
                                </div>

                                <Row className="g-2 mb-3 bg-light p-3 rounded border">
                                    <Col md={6}>
                                        <small className="text-muted d-block">Setor Proposto:</small>
                                        <strong>{pendenciaAtual.descsetornovo || pendenciaAtual.setor || "--"}</strong>
                                    </Col>
                                    <Col md={6}>
                                        <small className="text-muted d-block">Função Proposta:</small>
                                        <strong>{pendenciaAtual.descfuncnova || pendenciaAtual.funcao || "--"}</strong>
                                    </Col>
                                    <Col md={6} className="mt-2">
                                        <small className="text-muted d-block">Salário Novo:</small>
                                        <strong className="text-success">
                                            {pendenciaAtual.salarionovo
                                                ? pendenciaAtual.salarionovo.toLocaleString("pt-br", {
                                                    style: "currency",
                                                    currency: "BRL",
                                                })
                                                : "--"}
                                        </strong>
                                    </Col>
                                    <Col md={6} className="mt-2">
                                        <small className="text-muted d-block">Data Efetiva da Mudança:</small>
                                        <strong className="text-danger">
                                            {formatarDataSemFuso(pendenciaAtual.dataefetivo)}
                                        </strong>
                                    </Col>
                                </Row>

                                <Form.Group className="mb-2">
                                    <Form.Label className="fw-bold small">Observações / Considerações:</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={2}
                                        placeholder="Digite uma observação (opcional)..."
                                        value={motivoAssinatura}
                                        onChange={(e) => setMotivoAssinatura(e.target.value)}
                                    />
                                </Form.Group>
                            </div>
                        )
                    )}
                </Modal.Body>

                <Modal.Footer className="d-flex justify-content-between">
                    <Button
                        variant="secondary"
                        size="sm"
                        onClick={() => setShowModalPendencia(false)}
                        disabled={processandoAcao}
                    >
                        Fechar
                    </Button>

                    {pendenciaAtual?.tipoPendencia === "AVISO_REdirecionar" ? (
                        <Button
                            variant="primary"
                            className="fw-bold px-4"
                            onClick={() => {
                                window.location.href = "/arbor/comunicado";
                            }}
                        >
                            Abrir Janela ➔
                        </Button>
                    ) : (
                        <Button
                            variant="info"
                            className="text-white fw-bold px-4"
                            onClick={handleConfirmarCiencia}
                            disabled={processandoAcao}
                        >
                            {processandoAcao ? <Spinner animation="border" size="sm" /> : "ESTOU CIENTE"}
                        </Button>
                    )}
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default Home;